// @ts-nocheck
import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { ToCamelCase, Truncate } from '../../util/formatter';
import icons from '../../constants/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

function TableScopes({ scopes, tableSettings, setTableSettings }) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleRemoveScope = (scope) => {
    if (location) {
      const params = new URLSearchParams(location.search);
      params.delete(`s_${[ToCamelCase(scope.scope)]}`);
      navigate({
        pathname: location.pathname,
        search: params.toString(),
      });

      setTableSettings({
        ...tableSettings,
        scopes: Object.keys(tableSettings.scopes).reduce((acc, key) => {
          if (key.toLowerCase() !== scope.scope.toLowerCase()) {
            acc[key] = tableSettings.scopes[key];
          }
          return acc;
        }, {}),
      });
    } else {
      console.error('Location not supplied to table');
    }
  };

  const scopeButtonClassName = (scope) => {
    switch (scope.scope) {
      case 'Game':
      case 'Sku':
      case 'KeyProvider':
      case 'PackageType':
      case 'Platform':
      case 'KeyWorkflow':
      case 'Company':
      case 'User':
      case 'ApproverUser':
      case 'RequesterUser':
      case 'ApproverCompany':
      case 'RequesterCompany':
      case 'AllowedTerritory':
      case 'DisallowedTerritory':
        return 'ps-3';
      case 'HasTerritory':
      default:
        return '';
    }
  };

  const scopeDisplayName = (scope) => {
    scope.name = Truncate(scope.name, 150);
    switch (scope.scope) {
      case 'Game':
        return (
          <>
            <span className="icon-wrapper me-3 text-aqua">
              <FontAwesomeIcon icon={icons.GAME} />
            </span>
            {scope.name}
          </>
        );
      case 'Sku':
        return (
          <>
            <span className="icon-wrapper me-3 text-aqua">
              <FontAwesomeIcon icon={icons.SKU} />
            </span>
            {scope.name}
          </>
        );
      case 'KeyProvider':
        return (
          <>
            <span className="icon-wrapper me-3 text-blue">
              <FontAwesomeIcon icon={icons.KEY_PROVIDER} />
            </span>
            {scope.name}
          </>
        );
      case 'PackageType':
        return (
          <>
            <span className="icon-wrapper me-3 text-blue">
              <FontAwesomeIcon icon={icons.PACKAGE_TYPE} />
            </span>
            {scope.name}
          </>
        );
      case 'Platform':
        return (
          <>
            <span className="icon-wrapper me-3 text-blue">
              <FontAwesomeIcon icon={icons.PLATFORM} />
            </span>
            {scope.name}
          </>
        );
      case 'KeyWorkflow':
        return (
          <>
            <span className="icon-wrapper me-3 text-blue">
              <FontAwesomeIcon icon={icons.WORKFLOW} />
            </span>
            {scope.name}
          </>
        );
      case 'Company':
        return (
          <>
            <span className="icon-wrapper me-3 text-blue">
              <FontAwesomeIcon icon={icons.COMPANY} />
            </span>
            {scope.name}
          </>
        );
      case 'User':
        return (
          <>
            <span className="icon-wrapper me-3 text-blue">
              <FontAwesomeIcon icon={icons.USER} />
            </span>
            {scope.name}
          </>
        );
      case 'ApproverUser':
        return (
          <>
            <span className="icon-wrapper me-3 text-blue">
              <FontAwesomeIcon icon={icons.USER} />
            </span>
            {t('Approver')} : {scope.name}
          </>
        );
      case 'RequesterUser':
        return (
          <>
            <span className="icon-wrapper me-3 text-blue">
              <FontAwesomeIcon icon={icons.USER} />
            </span>
            {t('Requester')} : {scope.name}
          </>
        );
      case 'ApproverCompany':
        return (
          <>
            <span className="icon-wrapper me-3 text-blue">
              <FontAwesomeIcon icon={icons.COMPANY} />
            </span>
            {t('Approver')} : {scope.name}
          </>
        );
      case 'RequesterCompany':
        return (
          <>
            <span className="icon-wrapper me-3 text-blue">
              <FontAwesomeIcon icon={icons.COMPANY} />
            </span>
            {t('Requester')} : {scope.name}
          </>
        );
      case 'AllowedTerritory':
        return (
          <>
            <span className="icon-wrapper me-3 text-aqua">
              <FontAwesomeIcon icon={icons.TERRITORIES} />
            </span>
            {t('Allowed territory')} : {scope.name}
          </>
        );
      case 'DisallowedTerritory':
        return (
          <>
            <span className="icon-wrapper me-3 text-aqua">
              <FontAwesomeIcon icon={icons.TERRITORIES} />
            </span>
            {t('Disallowed territory')} : {scope.name}
          </>
        );
      case 'HasTerritory':
        return (
          <>
            <span className="icon-wrapper me-3 text-aqua">
              <FontAwesomeIcon icon={icons.TERRITORIES} />
            </span>
            {t('Users with territory')} : {scope.name}
          </>
        );
      default:
        return scope.name;
    }
  };

  return scopes.map((x) => (
    <button
      className={`btn btn-default btn-outline btn-filter me-2 ${scopeButtonClassName(
        x
      )}`}
      key={x.name}
      onClick={() => handleRemoveScope(x)}
      title={t('Remove filter')}
    >
      {scopeDisplayName(x)}
      <span className="icon-wrapper ms-3">
        <FontAwesomeIcon icon={icons.DELETE_TAG} />
      </span>
    </button>
  ));
}



export default TableScopes;
